import React from "react";
import {Link} from 'react-router-dom'

// reactstrap components
import {
    Button,
    Card,
    CardBody,
    CardHeader,
    CardTitle,
    Col,
    Form,
    FormGroup,
    Input,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
    Label,
    Row,
    Table,
} from "reactstrap";


import apiRequest from "../../../lib/Api";
import ConfirmModal from "../../../components/Modals/ConfirmModal";
import withNotify from "../../../lib/NotificationWrapper";

import PaginationCtrl from "components/Pagination/PaginationCtrl";
import moment from "moment";


class PatientList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            users: [],
            meta: {},
            filter: '',
            exportInterval: 30
        };
    }
    componentDidUpdate(prevProps) {
        // TODO use params instead
        if (this.props.match.path !== prevProps.match.path) {
            this.requestData();
        }
    }

    componentDidMount() {
        this.requestData();
    }

    requestData = page => {
        let data = {
            page: page || 1
        };

        if (this.state.filter) {
            data.search = this.state.filter;
        }

        apiRequest("/patients", {method: "GET", data})
            .then(response => {
                let {data, meta} = response.data;
                console.log(data);
                this.setState({users: data, meta});
            });
    }

    filterChange = (event) => {
        let value = event.target.value;
        this.setState({filter: value});
    }

    executeFilter = (event) => {
        event.preventDefault();
        this.requestData();
    }


    changeInterval = event => {
        let exportInterval = event.target.value;
        this.setState({exportInterval});
    }

    export = () => {
       let data = {};
        if (this.state.filter) {
            data.search = this.state.filter;
        }
        apiRequest("/patients/export", {method: "GET", data}, {blob: true})
            .then(blob => {
                const url = window.URL.createObjectURL(new Blob([blob]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'users.xlsx');
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
            })
    }

    renderStatus(user) {
        return user.user_program_status ? user.user_program_status.current_service.display_name : " Nenhuma consulta Agendada ";
    }

    renderLastAppointment(user) {
        if (user.user_program_status && user.user_program_status.current_appointment) {
            if (user.user_program_status.current_appointment.date) {
                return moment(user.user_program_status.current_appointment.date).format('DD/MM/YYYY');
            }
        }
        return " - ";
    }

    render() {
        let {users} = this.state;

        return (
            <>
                <div className="content">
                    <Row>
                        <Col md="12">
                            <Card>
                                <CardHeader>
                                    <CardTitle tag="h4">Pacientes</CardTitle>
                                </CardHeader>
                                <CardBody>
                                    <Form className="form-horizontal">
                                        <Row>
                                            <Col md="10">
                                                <FormGroup>
                                                    <InputGroup>
                                                        <Input placeholder="Nome ou e-mail" type="text"
                                                               onChange={this.filterChange} value={this.state.filter}
                                                               onKeyPress={event => {
                                                                   if (event.which === 13) {
                                                                       event.preventDefault();
                                                                       this.executeFilter(event);
                                                                   }
                                                               }
                                                               }
                                                        />
                                                        <InputGroupAddon addonType="append">
                                                            <InputGroupText style={{borderColor:'#848484'}}>
                                                                <i className="fa fa-search"
                                                                   onClick={this.executeFilter}/>
                                                            </InputGroupText>
                                                        </InputGroupAddon>
                                                    </InputGroup>
                                                </FormGroup>
                                            </Col>
                                            <Col md="2">
                                                <Button color="default" type="button" style={{margin: 0}}
                                                        onClick={this.export}
                                                >
                                                    Exportar Excel
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Form>
                                    <Table responsive striped hover>
                                        <thead>
                                        <tr>

                                            <th>Nome</th>
                                            <th>E-mail</th>
                                            <th>Nutricionista</th>
                                            <th>Andamento no Programa</th>
                                            <th>Último Agendamento</th>
                                            <th>Data de Ingresso</th>
                                        </tr>
                                        </thead>
                                        <tbody>

                                        {users.map(user => {

                                            return <tr key={user.id}>
                                                <td>{user.name}</td>
                                                <td>{user.email}</td>
                                                <td>{user.specialist.name}</td>
                                                <td>{this.renderStatus(user)}</td>
                                                <td>{this.renderLastAppointment(user)}</td>
                                                <td>{moment(user.created_at).format('DD/MM/YYYY')}</td>
                                            </tr>;

                                        })}

                                        </tbody>
                                    </Table>
                                    <PaginationCtrl responseMeta={this.state.meta}
                                                    requestPage={this.requestData}
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </>
        );
    }
}

export default withNotify(PatientList);
